export const REFERER_WEBAPP = 'ohc_Referer-Webapp'
export const TIMEZONE = 'ohc_TZ'
export const LANG = 'ohc_Lang'
export const RETURN_URL = 'ohc_Return-Url'
export const DEFAULT_INTERCEPT_ERROR = 'ohc_Default-Intercept-Error'

export default {
	REFERER_WEBAPP,
	TIMEZONE,
	LANG,
	RETURN_URL,
	DEFAULT_INTERCEPT_ERROR,
}


// WEBPACK FOOTER //
// ./src/constants/customHeaders.js